/*
* 讯飞文字转语音
* 配置在ProjectConfig
*/
/* eslint-disable no-undef */
class broadcast {
  constructor() {
    this.ttsWS = null
    this.init()
  }

  init () {
    // 从 window 对象获取 AudioPlayer
    this.audioPlayer = new window.AudioPlayer("static/tts-demo/dist");
  }

  play (option) {
    console.log('broadcast.play 被调用，文本:', option.text ? option.text.substring(0, 20) + '...' : '空')
    this.stop();
    this.connectWebSocket(option);
  }

  stop () {
    console.log('broadcast.stop 被调用')
    // 关闭 WebSocket 连接
    if (this.ttsWS) {
      try {
        this.ttsWS.close(1000, '正常关闭');
      } catch (e) {
        console.log('关闭 WebSocket 出错:', e)
      }
      this.ttsWS = null;
    }
    // 停止音频播放
    try {
      this.audioPlayer.stop();
      this.audioPlayer.reset();
    } catch (e) {
      console.log('停止音频出错:', e)
    }
    console.log('broadcast.stop 完成')
  }

  getWebSocketUrl () {
    var url = "wss://tts-api.xfyun.cn/v2/tts";
    var host = location.host;
    var date = new Date().toGMTString();
    var algorithm = "hmac-sha256";
    var headers = "host date request-line";
    var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/tts HTTP/1.1`;
    var signatureSha = window.CryptoJS.HmacSHA256(signatureOrigin, window.broadcastConfig.API_SECRET);
    var signature = window.CryptoJS.enc.Base64.stringify(signatureSha);
    var authorizationOrigin = `api_key="${window.broadcastConfig.API_KEY}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
    var authorization = btoa(authorizationOrigin);
    url = `${url}?authorization=${authorization}&date=${date}&host=${host}`;
    return url;
  }

  encodeText (text, type) {
    if (type === "unicode") {
      // 讯飞 TTS API 要求 UTF-16LE 编码
      let buf = new ArrayBuffer(text.length * 2);
      let bufView = new Uint16Array(buf);
      for (let i = 0; i < text.length; i++) {
        bufView[i] = text.charCodeAt(i);
      }
      // 转换为小端序字节
      let binary = "";
      let bytes = new Uint8Array(buf);
      for (let i = 0; i < bytes.length; i += 2) {
        // 小端序：低字节在前，高字节在后
        binary += String.fromCharCode(bytes[i]);     // 低字节
        binary += String.fromCharCode(bytes[i + 1]); // 高字节
      }
      return window.btoa(binary);
    } else {
      return window.Base64.encode(text);
    }
  }

  // 开始合成语音
  connectWebSocket (option = {}) {
    const url = this.getWebSocketUrl();
    this.ttsWS?.close();

    if ("WebSocket" in window) {
      this.ttsWS = new WebSocket(url);
    } else if ("MozWebSocket" in window) {
      this.ttsWS = new MozWebSocket(url);
    } else {
      alert("浏览器不支持WebSocket");
      return;
    }

    if (!option.text || !option.vcn) {
      console.log(option.text ? "未传入对话" : "未传入音源")
      return
    }
    this.ttsWS.onopen = () => {
      this.audioPlayer.start({
        autoPlay: true,
        sampleRate: 16000,
        resumePlayDuration: 1000
      });
      console.log(this.audioPlayer)
      var tte = "unicode"; // unicode小语种
      var str = this.encodeText(option.text, tte)
      var params = {
        common: {
          app_id: window.broadcastConfig.APPID,
        },
        business: {
          aue: "raw",
          auf: "audio/L16;rate=16000",
          vcn: option.vcn, // 发音人
          speed: window.broadcastConfig.speed || 50,
          volume: window.broadcastConfig.volume || 50,
          pitch: window.broadcastConfig.pitch || 40,
          bgs: 0,
          tte
        },
        data: {
          status: 2,
          text: str
        },
      };
      this.ttsWS.send(JSON.stringify(params));
    };
    this.ttsWS.onmessage = (e) => {
      console.log('收到 WebSocket 消息')
      let jsonData = JSON.parse(e.data);
      // 合成失败
      if (jsonData.code !== 0) {
        console.error(jsonData);
        return;
      }
      console.log('音频数据长度:', jsonData.data.audio ? jsonData.data.audio.length : 0, '状态:', jsonData.data.status)
      this.audioPlayer.postMessage({
        type: "base64",
        data: jsonData.data.audio,
        isLastData: jsonData.data.status === 2,
      });
      if (jsonData.code === 0 && jsonData.data.status === 2) {
        console.log('收到最后一条数据，关闭 WebSocket')
        this.ttsWS.close();
      }
    };
    this.ttsWS.onerror = (e) => {
      console.error(e);
    };
    this.ttsWS.onclose = (e) => {
      console.log(e);
    };
  }
}

export default broadcast
